import { motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { getItemByName } from "./Functions";
import Loader from "./Loader01";
const InventoryItem = ({ t, item, onClick, opacity }) => {
  const [itemDetails, setItemDetails] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  useEffect(() => {
    const fetchItemDetails = async () => {
      const details = await getItemByName(item.title);
      setItemDetails(details);
    };
    fetchItemDetails();
  }, [item.title]);

  if (!itemDetails) return null;

  return (
    <motion.div
      whileTap={{ scale: 0.97 }}
      transition={{ duration: 0.1 }}
      onClick={onClick}
      style={{ backgroundColor: itemDetails.color, opacity: opacity }}
      className="table-item"
    >
      {/* <div className="table-item-name">{t(item.title)}</div> */}
      {/* {isImageLoading && (
        <div className="spinner" style={{ inset: 0 }}>
          <Loader size={30} color="white"></Loader>
        </div>
      )} */}
      <img
        className="table-item-img"
        width={"100%"}
        src={itemDetails.miniimg}
        alt={`${item.title} image`}
        onLoad={() => setIsImageLoading(false)} // Изображение загружено
        onError={() => setIsImageLoading(false)} // Ошибка загрузки
      />
      <div
        style={{
          position: "absolute",
          left: 0,
          display: "flex",
          width: "100%",
          padding: "0px 4px",
          justifyContent: "flex-end",
          bottom: 4,
        }}
      >
        <div className="table-item-quantity">{item.quantity}</div>
      </div>
    </motion.div>
  );
};
export default InventoryItem;
